"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/page-header/style");
var _pageHeader = _interopRequireDefault(require("antd/lib/page-header"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _StaticChannelLayoutWrapper = _interopRequireDefault(require("./StaticChannelLayoutWrapper"));
var _roles = require("../../../../utils/roles.utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = _typography.default.Title;
var WelcomeStaticLayout = function WelcomeStaticLayout(_ref) {
  var ChannelHeader = _ref.ChannelHeader;
  return /*#__PURE__*/_react.default.createElement(_StaticChannelLayoutWrapper.default, {
    ChannelHeader: ChannelHeader
  }, /*#__PURE__*/_react.default.createElement(_pageHeader.default, {
    className: "mb-[30px] text-grey-75 px-0",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 3,
      className: "subtitle-small-medium text-center md:title-small-bold"
    }, "Welcome to the Monument Community!")
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-2 mb-4 body-big-light md:mb-5"
  }, "This is your judgement-free space to give and get support as you change your relationship with alcohol. To make this a safe environment for everyone, we ask that you adhere to the following community guidelines."), /*#__PURE__*/_react.default.createElement("div", {
    className: "community-guidelines flex flex-col items-left"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "label-small-medium mb-[1em]"
  }, "Be kind and thoughtful"), /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-4 body-big-light md:mb-5"
  }, "This is a place to lift each other up. There is no room for discriminatory, violent, threatening, hateful, judgmental, exclusionary, or insulting language. We expect community members to respond to each other with constructive, positive comments that they would be happy to receive themselves. We\u2019re all on the same team, and it should show."), /*#__PURE__*/_react.default.createElement("p", {
    className: "label-small-medium mb-[1em]"
  }, "Respect anonymity"), /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-4 body-big-light md:mb-5"
  }, "Anonymity is crucial to make everyone feel comfortable participating in our community. We will remove any comments mentioning private people or sharing/asking for personally identifiable information."), /*#__PURE__*/_react.default.createElement("p", {
    className: "label-small-medium mb-[1em]"
  }, "Avoid medical advice"), /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-4 body-big-light md:mb-5"
  }, "While we encourage you to share your experiences about clinicians and medications, if you have specific medical questions, please ask your ", (0, _roles.getRoleNameLower)(_roles.UserRoles.Doctor), " or", (0, _roles.getRoleNameLower)(_roles.UserRoles.Therapist), ". Posts in the community forum, from moderators or members, ", /*#__PURE__*/_react.default.createElement("span", {
    className: "underline"
  }, "should not be taken as medical advice"), "."), /*#__PURE__*/_react.default.createElement("p", {
    className: "label-small-medium mb-[1em]"
  }, "Avoid promotional posting"), /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-4 body-big-light md:mb-5"
  }, "Comments that promote social media accounts, businesses, products/services, and personal blogs distract from our mission and will be removed. Monument moderators will post articles for discussion, but other than that we ask that you please refrain from posting URLs.")));
};
var _default = WelcomeStaticLayout;
exports.default = _default;